// Product / Software Development add-on - USD only one-off purchase.
// Custom Solution routes to chat with the Account Manager.
export const PRODUCT_DEV_TIERS = [
  {
    id: 'starter',
    label: 'Product Starter',
    priceUSD: 2500,
    description: 'Discovery + specification + roadmap. Get clarity before building.',
    bullets: [
      'Discovery workshop',
      'Product specification',
      'Wireframes',
      'MVP planning',
      'Basic development roadmap',
    ],
    cta: 'Request Plan',
  },
  {
    id: 'growth',
    label: 'Product Growth',
    priceUSD: 5000,
    description: 'Build the MVP end-to-end with deployment support.',
    bullets: [
      'Everything in Starter',
      'MVP development',
      'User authentication',
      'Core product functionality',
      'Admin dashboard',
      'Deployment support',
    ],
    cta: 'Request Plan',
    highlight: true,
  },
  {
    id: 'custom',
    label: 'Custom Solution',
    priceUSD: null,
    customPriceLabel: 'Custom pricing based on project scope',
    description: 'Larger scope, ongoing engineering, AI products, marketplaces.',
    bullets: [
      'Tailored scope & team',
      'Custom integrations',
      'Long-term roadmap',
      'Dedicated account manager',
    ],
    cta: 'Talk to Account Manager',
    isCustom: true,
  },
];

export const PRODUCT_DEV_CURRENCY = 'usd';
export const PRODUCT_DEV_SYMBOL = '$';
